import { render } from "./MySongs.vue?vue&type=template&id=76104dd5&scoped=true&ts=true"
import script from "./MySongs.vue?vue&type=script&lang=ts"
export * from "./MySongs.vue?vue&type=script&lang=ts"

import "./MySongs.vue?vue&type=style&index=0&id=76104dd5&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76104dd5"]])

export default __exports__